/**
 * personalizacao-camiseta.js
 * Controls the show/hide of Name + Number customization fields
 * Works with both PT (Personalizar/Não Personalizar) and EN (Customize/Don't Customize)
 */
(function() {
  'use strict';

  // Values that mean "YES, customize" (add both languages)
  const CUSTOMIZE_VALUES = [
    'customize', 'personalizar', 'sim', 'yes', 'add', 'adicionar'
  ];

  // Values that mean "NO, don't customize"  
  const NO_CUSTOMIZE_VALUES = [
    "don't customize", 'dont customize', 'não personalizar', 'nao personalizar',
    'não', 'nao', 'no', "don't", 'dont', 'no add', 'não adicionar'
  ];

  // Option names that indicate personalization
  const PERSONALIZACAO_KEYWORDS = [
    'personaliz', 'customize', 'custom', 'personali'
  ];

  function init() {
    // Find all product info sections
    const sections = document.querySelectorAll('product-info, [id^="ProductInfo-"]');
    
    sections.forEach(section => {
      const sectionId = section.id?.replace('ProductInfo-', '') || 
                        section.dataset?.section || '';
      setupPersonalizacao(section, sectionId);
    });

    // Also listen for variant changes via MutationObserver for dynamic updates
    observeVariantChanges();
  }

  function setupPersonalizacao(section, sectionId) {
    const container = document.getElementById('personalizacao-container-' + sectionId);
    if (!container) return;

    // Find the personalization option fieldset
    const fieldsets = section.querySelectorAll('fieldset, .product-form__input');
    
    fieldsets.forEach(fieldset => {
      const legend = fieldset.querySelector('legend, .form__label, label');
      if (!legend) return;
      
      const legendText = legend.textContent.toLowerCase().trim();
      const isPersonalizacao = PERSONALIZACAO_KEYWORDS.some(kw => legendText.includes(kw));
      
      if (!isPersonalizacao) return;

      // Found the personalization option - listen to its inputs
      const inputs = fieldset.querySelectorAll('input[type="radio"], input[type="hidden"], select');
      
      inputs.forEach(input => {
        if (input.type === 'radio') {
          input.addEventListener('change', () => {
            handleOptionChange(input.value, container, sectionId);
          });
          // Check initial state
          if (input.checked) {
            handleOptionChange(input.value, container, sectionId);
          }
        } else if (input.tagName === 'SELECT') {
          input.addEventListener('change', () => {
            handleOptionChange(input.value, container, sectionId);
          });
          handleOptionChange(input.value, container, sectionId);
        }
      });

      // Also listen for clicks on variant buttons (Dawn theme pattern)
      const buttons = fieldset.querySelectorAll('.product-form__input label, [data-option-value]');
      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          setTimeout(() => {
            const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
            if (checkedInput) {
              handleOptionChange(checkedInput.value, container, sectionId);
            }
          }, 50);
        });
      });
    });

    // Setup number field validation
    const numInput = document.getElementById('personalizacao-numero-' + sectionId);
    if (numInput) {
      numInput.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '').slice(0, 3);
      });
    }

    // Setup name field - uppercase and limit
    const nameInput = document.getElementById('personalizacao-nome-' + sectionId);
    if (nameInput) {
      nameInput.addEventListener('input', function() {
        if (this.value.length > 20) {
          this.value = this.value.slice(0, 20);
        }
      });
    }
  }

  function handleOptionChange(value, container, sectionId) {
    const val = value.toLowerCase().trim();

    const isCustomize = CUSTOMIZE_VALUES.some(cv => val === cv || val.includes(cv));
    const isNoCustomize = NO_CUSTOMIZE_VALUES.some(nv => val === nv || val.includes(nv));

    const alvo = isCustomize && !isNoCustomize ? 'block' : 'none';
    // Idempotente: sem isso, o resync() abaixo reescreveria o display a
    // cada passada e poderia realimentar o MutationObserver.
    if (container.style.display === alvo) return;

    if (alvo === 'block') {
      container.style.display = 'block';
    } else {
      container.style.display = 'none';
      // Clear fields when hiding
      const nameInput = document.getElementById('personalizacao-nome-' + sectionId);
      const numInput = document.getElementById('personalizacao-numero-' + sectionId);
      if (nameInput) nameInput.value = '';
      if (numInput) numInput.value = '';
    }
  }

  /* ------------------------------------------------------------------
     Resiliência à troca do seletor de variante.

     A cada mudança de variante o tema NÃO altera o seletor existente:
     ele monta um <variant-selects> novo e descarta o antigo
     (HTMLUpdateUtility.viewTransition). Os listeners que o init() acima
     prendeu nos inputs antigos morrem junto, e o único gatilho de
     re-init era a mudança de URL. Dentro do modal de compra rápida a URL
     nunca muda (o quick-add força data-update-url="false"), então depois
     da primeira troca de tamanho o "Customize" parava de abrir os campos
     de Nome e Número. As duas peças abaixo cobrem isso sem depender de
     listener preso a elemento nenhum.
  ------------------------------------------------------------------ */

  function acharFieldsetPersonalizacao(el) {
    const fieldset = el.closest && el.closest('fieldset, .product-form__input');
    if (!fieldset) return null;
    const legend = fieldset.querySelector('legend, .form__label, label');
    if (!legend) return null;
    const txt = legend.textContent.toLowerCase().trim();
    return PERSONALIZACAO_KEYWORDS.some(kw => txt.includes(kw)) ? fieldset : null;
  }

  function containerDoInput(el) {
    const section = el.closest('product-info, [id^="ProductInfo-"]');
    const sectionId =
      (section && section.id ? section.id.replace('ProductInfo-', '') : '') ||
      (section && section.dataset ? section.dataset.section : '') || '';
    return { container: document.getElementById('personalizacao-container-' + sectionId), sectionId };
  }

  // Lê o que está marcado AGORA e ajusta o container. Serve pro caso do
  // seletor ter sido recriado já com "Customize" selecionado, situação em
  // que nenhum evento de mudança chega a disparar.
  function resync() {
    document.querySelectorAll('[id^="personalizacao-container-"]').forEach(function (container) {
      const sectionId = container.id.replace('personalizacao-container-', '');
      const section =
        document.getElementById('ProductInfo-' + sectionId) ||
        document.querySelector('product-info[data-section="' + sectionId + '"]');
      if (!section) return;
      const marcado = Array.prototype.slice
        .call(section.querySelectorAll('input[type="radio"]:checked, select'))
        .filter(acharFieldsetPersonalizacao)[0];
      if (marcado) handleOptionChange(marcado.value, container, sectionId);
    });
  }

  // O <script> é reinjetado toda vez que o modal de compra rápida abre,
  // então os ganchos globais precisam ser instalados uma única vez.
  if (!window.__cdrPersonalizacaoHooks) {
    window.__cdrPersonalizacaoHooks = true;

    document.addEventListener(
      'change',
      function (e) {
        const input = e.target;
        if (!input || (input.type !== 'radio' && input.tagName !== 'SELECT')) return;
        if (!acharFieldsetPersonalizacao(input)) return;
        const alvo = containerDoInput(input);
        if (alvo.container) handleOptionChange(input.value, alvo.container, alvo.sectionId);
      },
      true
    );

    let resyncAgendado = false;
    new MutationObserver(function (muts) {
      // só reage quando um seletor de variante NOVO entra na página;
      // mudança de atributo (como o próprio display do container) é
      // ignorada de propósito, pra não realimentar o observer
      const relevante = muts.some(function (mu) {
        return Array.prototype.slice.call(mu.addedNodes).some(function (n) {
          if (n.nodeType !== 1) return false;
          return (
            (n.matches && n.matches('variant-selects, .product-form__input')) ||
            (n.querySelector && n.querySelector('variant-selects, .product-form__input'))
          );
        });
      });
      if (!relevante || resyncAgendado) return;
      resyncAgendado = true;
      requestAnimationFrame(function () {
        resyncAgendado = false;
        resync();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function observeVariantChanges() {
    // Re-check on URL changes (variant switching)
    let lastUrl = location.href;
    const observer = new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        setTimeout(init, 100);
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Also re-init after a short delay (handles slow-loading variant pickers)
  setTimeout(init, 500);
  setTimeout(init, 1500);
})();
